module.exports = "<div class=\"playback-progress\">\n        <div class=\"playback-bar\" [ngStyle]=\"{'width.%':progress}\"></div>\n    </div>"